module.exports = __webpack_public_path__ + "media/images/games/35gender/buildingwithblocks-dfb21f622240c6aad38a7cd7bd1a597d.png";